module.exports = __webpack_public_path__ + "img/line.2d470c16.svg";